// extracted by mini-css-extract-plugin
module.exports = {"titleBox":"index-module--title-box--1bbjY"};